import type { ExpenseStatus } from "./expense-status";

/** ພິມໃບຫຼັງອະນຸມັດ ຫຼື ຈ່າຍແລ້ວ */
export const PRINTABLE_EXPENSE_STATUSES: ExpenseStatus[] = [
  "approved",
  "paid",
  "closed",
];

export function isExpenseRecordPrintable(status: string): boolean {
  return PRINTABLE_EXPENSE_STATUSES.includes(status as ExpenseStatus);
}
